/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userManager } from "services/auth-service/auth";

export const SigninCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    void userManager.signinRedirectCallback()
      .then((user) => {
        if (user) {
          user.state ? navigate(user.state.redirect, { replace: true }) : navigate("/", { replace: true });
        }
      })
      .catch((error) => {
        console.error("sign-in error", error);
        navigate("/", { replace: true });
      });
  }, [navigate]);

  return null;
};

export const SigninPopupCallback = () => {
  userManager.signinPopupCallback();
  return null;
};

export const SilentSigninCallback = () => {

  userManager.signinSilentCallback()
    .catch((error) => console.error("silent sign-in error", error));

  return null;
};
